import { PluginKey } from '@tiptap/pm/state'
import { useEditorState } from '@tiptap/react'
import { BubbleMenu } from '@tiptap/react/menus'
import { useEditor } from '../store/context'

const pluginKey = new PluginKey('linkBubbleMenu')

function truncate(url: string, max = 50): string {
  return url.length > max ? `${url.slice(0, max)}…` : url
}

export function LinkBubble() {
  const { view, store } = useEditor()

  const href = useEditorState({
    editor: store.ready ? store.editor() : null,
    selector: ({ editor }) => (editor?.getAttributes('link').href as string | undefined) ?? '',
  }) ?? ''

  if (!store.ready)
    return null

  const editor = store.editor()

  return (
    <BubbleMenu
      editor={editor}
      pluginKey={pluginKey}
      className="tiptap-link-bubble"
      shouldShow={({ editor: ed }) => !view.sourceMode && ed.isActive('link')}
    >
      <a
        className="bubble-url"
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        title={href}
      >
        {truncate(href)}
      </a>
      <span className="bubble-sep" />
      <button
        type="button"
        className="bubble-btn"
        onMouseDown={(e) => {
          e.preventDefault()
          store.openLinkDialog()
        }}
      >
        Edit
      </button>
      <button
        type="button"
        className="bubble-btn bubble-btn--danger"
        onMouseDown={(e) => {
          e.preventDefault()
          editor.chain().focus().extendMarkRange('link').unsetLink().run()
        }}
      >
        Remove
      </button>
    </BubbleMenu>
  )
}
